/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

import usePageOffset from "../../../hooks/usePageOffset";
import useShowNavStore from "../../../sp-state/useShowNavStore";
import useShowPollenNavStore from "../../../sp-state/useShowPollenNavStore";
import useWindowSize from "../../../hooks/useWindowSize";
import useIsStickyPollenNavStore from "../../../sp-state/useIsStickyPollenNavStore";

export default function usePollenNavEffects() {
  const { setIsSticky, resetIsSticky } = useIsStickyPollenNavStore(
    state => state
  );
  const { showNav, resetShowNav } = useShowNavStore(state => state);
  const { showPollenNav, resetShowPollenNav } = useShowPollenNavStore(
    state => state
  );
  const { y: pageOffSetY } = usePageOffset();
  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    if (pageOffSetY > 200) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  }, [pageOffSetY, setIsSticky]);

  useEffect(() => {
    if (showNav && windowWidth >= 767) {
      resetShowNav();
    }

    if (showPollenNav && windowWidth >= 1024) {
      resetShowPollenNav();
    }
  }, [windowWidth]);

  useEffect(() => {
    return () => {
      resetIsSticky();
      resetShowNav();
      resetShowPollenNav();
    };
  }, []);
}
